exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xform-custom-radio.has-error .ant-radio-inner {\n  border-color: #f50;\n}\n.xform-custom-radio .vertical .ant-radio-wrapper {\n  display: block;\n  height: 25px;\n  line-height: 25px;\n}\n", ""]);

// exports
